const home = {
  infoWindow: {
    area: "Province",
    licencePlate: "License plate",
    title: "Vehicle information",
    model: "Model",
    brand: "Brand",
    dataTime: "Data time",
    gpsSpeed: "GPS speed",
    gpsMileage: "GPS mileage",
    monitor: "Vehicle Monitoring",
    obd: "OBD code",
    gpsTime: "Gps time",
    series: "Series",
    speed: "Speed"
  }
} 
export default home